import React, { useState, useEffect } from "react";
import "./Enquiries.css";
import Header from "../header/Header";
import Sidebar from "../Sidebar";
import Footer from "../footer/Footer";
import VivahApi from "../../api";

const STATUS_LABELS = { new: 'New', read: 'Read', replied: 'Replied' };
const STATUS_COLORS = { new: '#e91e63', read: '#f59e0b', replied: '#22c55e' };

function AdminEnquiries() {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading]     = useState(false);
  const [expanded, setExpanded]   = useState(null);
  const [updating, setUpdating]   = useState(null);
  const [filter, setFilter]       = useState('all');

  useEffect(() => {
    try {
      const authService = require('../../services/auth.service').default;
      if (!authService.isAdmin()) window.location.replace('/');
    } catch (e) { window.location.replace('/'); }
  }, []);

  useEffect(() => {
    fetchEnquiries();
  }, []);

  async function fetchEnquiries() {
    setLoading(true);
    try {
      const res = await VivahApi.Admin.listEnquiries();
      setEnquiries(res.data.enquiries || []);
    } catch (err) {
      console.error('Failed to load enquiries', err);
    } finally {
      setLoading(false);
    }
  }

  async function handleStatusChange(enquiryId, status) {
    setUpdating(enquiryId);
    try {
      await VivahApi.Admin.updateEnquiryStatus(enquiryId, status);
      setEnquiries(prev => prev.map(e => e.enquiryId === enquiryId ? { ...e, status } : e));
    } catch (err) {
      console.error('Failed to update status', err);
    } finally {
      setUpdating(null);
    }
  }

  const filtered = filter === 'all' ? enquiries : enquiries.filter(e => e.status === filter);

  const counts = enquiries.reduce((acc, e) => {
    acc[e.status] = (acc[e.status] || 0) + 1;
    return acc;
  }, {});

  return (
    <>
      <div className="gla_page" id="gla_page">
        <a href="#gla_page" className="gla_top ti ti-angle-up gla_go"></a>
        <Header />
        <div className="gla_page_title gla_image_bck gla_wht_txt" data-color="#282828">
          <div className="container text-left">
            <div className="row">
              <div className="col-md-8">
                <h1 className="gla_h1_title">Enquiries</h1>
              </div>
            </div>
          </div>
        </div>
        <section id="gla_content" className="gla_content">
          <section className="gla_section">
            <div className="dashboard">
              <div className="row">
                <Sidebar />
                <div className="col-md-10 col-xs-12 dashboard_container">

                  <div className="enq-header">
                    <div className="enq-filter-tabs">
                      {['all', 'new', 'read', 'replied'].map(f => (
                        <button
                          key={f}
                          className={`enq-tab${filter === f ? ' active' : ''}`}
                          onClick={() => setFilter(f)}
                        >
                          {f === 'all' ? 'All' : STATUS_LABELS[f]}
                          <span className="enq-tab-count">
                            {f === 'all' ? enquiries.length : (counts[f] || 0)}
                          </span>
                        </button>
                      ))}
                    </div>
                  </div>

                  {loading ? (
                    <div className="enq-loading">Loading enquiries…</div>
                  ) : filtered.length === 0 ? (
                    <div className="enq-empty">No enquiries found.</div>
                  ) : (
                    <div className="enq-list">
                      {filtered.map(enq => (
                        <div key={enq.enquiryId} className={`enq-card enq-status-${enq.status}`}>
                          <div className="enq-card-header" onClick={() => setExpanded(expanded === enq.enquiryId ? null : enq.enquiryId)}>
                            <div className="enq-card-left">
                              <span className="enq-status-dot" style={{ background: STATUS_COLORS[enq.status] || '#aaa' }}></span>
                              <div>
                                <div className="enq-name">{enq.name}</div>
                                <div className="enq-meta">{enq.email} &nbsp;·&nbsp; {enq.phone}</div>
                              </div>
                            </div>
                            <div className="enq-card-right">
                              <span className="enq-date">{new Date(enq.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                              <span className={`enq-badge enq-badge-${enq.status}`}>{STATUS_LABELS[enq.status] || enq.status}</span>
                              <i className={`ti ti-angle-${expanded === enq.enquiryId ? 'up' : 'down'} enq-chevron`}></i>
                            </div>
                          </div>

                          {expanded === enq.enquiryId && (
                            <div className="enq-card-body">
                              {enq.message ? (
                                <p className="enq-message">{enq.message}</p>
                              ) : (
                                <p className="enq-message enq-message-empty">No message provided.</p>
                              )}
                              <div className="enq-actions">
                                <a href={`mailto:${enq.email}?subject=Re: Your enquiry — VivahBandh`} className="enq-btn enq-btn-reply">
                                  <i className="ti ti-email"></i> Reply via Email
                                </a>
                                <div className="enq-status-actions">
                                  <span className="enq-status-label">Mark as:</span>
                                  {['new', 'read', 'replied'].map(s => (
                                    <button
                                      key={s}
                                      className={`enq-btn enq-btn-status${enq.status === s ? ' active' : ''}`}
                                      disabled={enq.status === s || updating === enq.enquiryId}
                                      onClick={() => handleStatusChange(enq.enquiryId, s)}
                                    >
                                      {updating === enq.enquiryId ? '…' : STATUS_LABELS[s]}
                                    </button>
                                  ))}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}

                </div>
              </div>
            </div>
          </section>
        </section>
        <Footer />
      </div>
    </>
  );
}

export default AdminEnquiries;
